<h3 class="text-center text-thin">Alerts</h3>
<ul class="nav">
    <!-- START list title-->
    <li class="p">
        <small class="text-muted">Today</small>
    </li>
  <!-- END list title-->
    <li>
        <!--&lt;!&ndash; START User status&ndash;&gt;-->
        <!--<a href="#" class="media-box p mt0">-->
            <!--<span class="pull-right">-->
                         <!--<span class="circle circle-success circle-lg"></span>-->
            <!--</span>-->
            <!--<span class="pull-left">-->
                         <!--&lt;!&ndash; Contact avatar&ndash;&gt;-->
                         <!--<img src="assets/img/user/05.jpg" alt="Image" class="media-box-object img-circle thumb48">-->
                      <!--</span>-->
          <!--&lt;!&ndash; Contact info&ndash;&gt;-->
            <!--<span class="media-box-body">-->
                         <!--<span class="media-box-heading">-->
                            <!--<strong>Juan Sims</strong>-->
                            <!--<br>-->
                            <!--<small class="text-muted">Designeer</small>-->
                         <!--</span>-->
            <!--</span>-->
        <!--</a>-->
      <!--&lt;!&ndash; END User status&ndash;&gt;-->
      <!--&lt;!&ndash; START User status&ndash;&gt;-->
        <!--<a href="#" class="media-box p mt0">-->
            <!--<span class="pull-right">-->
                         <!--<span class="circle circle-success circle-lg"></span>-->
            <!--</span>-->
            <!--<span class="pull-left">-->
                         <!--&lt;!&ndash; Contact avatar&ndash;&gt;-->
                         <!--<img src="assets/img/user/06.jpg" alt="Image" class="media-box-object img-circle thumb48">-->
                      <!--</span>-->
          <!--&lt;!&ndash; Contact info&ndash;&gt;-->
            <!--<span class="media-box-body">-->
                         <!--<span class="media-box-heading">-->
                            <!--<strong>Maureen Jenkins</strong>-->
                            <!--<br>-->
                            <!--<small class="text-muted">Designeer</small>-->
                         <!--</span>-->
            <!--</span>-->
        <!--</a>-->
      <!--&lt;!&ndash; END User status&ndash;&gt;-->
      <!--&lt;!&ndash; START User status&ndash;&gt;-->
        <!--<a href="#" class="media-box p mt0">-->
            <!--<span class="pull-right">-->
                         <!--<span class="circle circle-danger circle-lg"></span>-->
            <!--</span>-->
            <!--<span class="pull-left">-->
                         <!--&lt;!&ndash; Contact avatar&ndash;&gt;-->
                         <!--<img src="assets/img/user/07.jpg" alt="Image" class="media-box-object img-circle thumb48">-->
                      <!--</span>-->
          <!--&lt;!&ndash; Contact info&ndash;&gt;-->
            <!--<span class="media-box-body">-->
                         <!--<span class="media-box-heading">-->
                            <!--<strong>Billie Dunn</strong>-->
                            <!--<br>-->
                            <!--<small class="text-muted">Designeer</small>-->
                         <!--</span>-->
            <!--</span>-->
        <!--</a>-->
      <!--&lt;!&ndash; END User status&ndash;&gt;-->
      <!--&lt;!&ndash; START User status&ndash;&gt;-->
        <!--<a href="#" class="media-box p mt0">-->
            <!--<span class="pull-right">-->
                         <!--<span class="circle circle-warning circle-lg"></span>-->
            <!--</span>-->
            <!--<span class="pull-left">-->
                         <!--&lt;!&ndash; Contact avatar&ndash;&gt;-->
                         <!--<img src="assets/img/user/08.jpg" alt="Image" class="media-box-object img-circle thumb48">-->
                      <!--</span>-->
          <!--&lt;!&ndash; Contact info&ndash;&gt;-->
            <!--<span class="media-box-body">-->
                         <!--<span class="media-box-heading">-->
                            <!--<strong>Tomothy Roberts</strong>-->
                            <!--<br>-->
                            <!--<small class="text-muted">Designer</small>-->
                         <!--</span>-->
            <!--</span>-->
        <!--</a>-->
      <!--&lt;!&ndash; END User status&ndash;&gt;-->
    <!--</li>-->
  <!--&lt;!&ndash; START list title&ndash;&gt;-->
    <!--<li class="p">-->
        <!--<small class="text-muted">Yesterday 23 oktober</small>-->
    <!--</li>-->
  <!--&lt;!&ndash; END list title&ndash;&gt;-->
    <!--<li>-->
        <!--&lt;!&ndash; START User status&ndash;&gt;-->
        <!--<a href="#" class="media-box p mt0">-->
            <!--<span class="pull-right">-->
                         <!--<span class="circle circle-lg"></span>-->
            <!--</span>-->
            <!--<span class="pull-left">-->
                         <!--&lt;!&ndash; Contact avatar&ndash;&gt;-->
                         <!--<img src="assets/img/user/09.jpg" alt="Image" class="media-box-object img-circle thumb48">-->
                      <!--</span>-->
          <!--&lt;!&ndash; Contact info&ndash;&gt;-->
            <!--<span class="media-box-body">-->
                         <!--<span class="media-box-heading">-->
                            <!--<strong>Lawrence Robinson</strong>-->
                            <!--<br>-->
                            <!--<small class="text-muted">Developer</small>-->
                         <!--</span>-->
            <!--</span>-->
        <!--</a>-->
      <!--&lt;!&ndash; END User status&ndash;&gt;-->
      <!--&lt;!&ndash; START User status&ndash;&gt;-->
        <!--<a href="#" class="media-box p mt0">-->
          <!--<span class="pull-right">-->
                       <!--<span class="circle circle-lg"></span>-->
          <!--</span>-->
          <!--<span class="pull-left">-->
             <!--&lt;!&ndash; Contact avatar&ndash;&gt;-->
             <!--<img src="assets/img/user/10.jpg" alt="Image" class="media-box-object img-circle thumb48">-->
          <!--</span>-->
          <!--&lt;!&ndash; Contact info&ndash;&gt;-->
          <!--<span class="media-box-body">-->
             <!--<span class="media-box-heading">-->
                <!--<strong>Tyrone Owens</strong>-->
                <!--<br>-->
                <!--<small class="text-muted">Designer</small>-->
             <!--</span>-->
          <!--</span>-->
        <!--</a>-->
      <!-- END User status-->
    </li>
</ul>
